import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogContentExampleDialog } from 'src/app/feature-modules/orders/components/title/title.component';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent {

  isExpanded: boolean = false;
  getUserName: string | null = sessionStorage.getItem('username');
  currentYear: number = new Date().getFullYear();
  isBusy: boolean = false;

  pdfFolderPath: string = 'assets/userguide/';
  pdfFileName: string = 'Introducing - Where is My Order.pdf';

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  toggleSidenav(): void {
    this.isExpanded = !this.isExpanded;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogContentExampleDialog, {
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  downloadPDF(): void {
    this.isBusy = true;

    const pdfUrl = 'assets/userguide/user-guide.pdf';

    fetch(pdfUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);

        window.open(objectUrl, '_blank');

        setTimeout(() => URL.revokeObjectURL(objectUrl), 2000);

        this.isBusy = false;

        this.snackBar.open('User guide opened successfully.', 'Close', {
          duration: 3000
        });

        this.cdr.detectChanges();
      })
      .catch(error => {
        this.isBusy = false;

        console.error('PDF download error:', error);

        this.snackBar.open(
          'Failed to download user guide. Please try again.',
          'Close',
          { duration: 3000 }
        );

        this.cdr.detectChanges();
      });
  }
}
